import React from 'react';
import styled from 'styled-components';
import { NoTranslate } from '@shared/components/no-translate/no-translate';
import { MobileScreen } from '../../../styles/ConstantMediaQuery';
import { ModalHeaderLogo } from '../../../texts/ModalHeaderStyles';
import ModalHeaderBackground from '../../generic-modal/header/ModalHeaderBackground';
import DefaultComponent from '../../../../utils/modalHeaderUtils';
import Images from '../../../../constants/ImageConstants';
import HeaderTagImageWithLabel from '../../../layouts/HeaderTagImageWithLabel';
import HeaderImageWithLabelWrapper from '../../../layouts/HeaderImageWithLabelWrapper';

const defaultProps = {
    children: null,
    client: null,
    shouldDisplayLabels: false,
    account: null,
    styles: {},
};

/**
 * @deprecated Use shared\components\modals\headers\modal-header\modal-header.tsx
 */
// eslint-disable-next-line complexity
const ModalHeader = ({
    children,
    data,
    styles,
    shouldDisplayLabels,
    account,
    client,
}) => {
    const { background = {}, shouldDisplayParetoLogo } = data;
    // TODO (Matheus): Refactor para tirar background e shouldDisplayParetoLogo de data
    const filteredData = Object
        .entries(data)
        .filter(([key]) => key !== 'background' && key !== 'shouldDisplayParetoLogo');

    return (
        <ModalHeaderBackground
            backgroundHeader={background}
            headerStyles={styles.modalHeaderBackground}
        >
            <Header headerStyles={styles.header} backgroundImage={data.background.backgroundImage}>
                {shouldDisplayParetoLogo && (
                    <ModalHeaderLogo
                        alt={Images.LOGOS.PARETO_WHITE.ALT}
                        src={Images.LOGOS.PARETO_WHITE.SRC}
                    />
                )}

                {filteredData
                    .map(([key, value]) => (
                        <DefaultComponent
                            key={key}
                            property={key}
                            value={value}
                        />
                    ))}
                {account && shouldDisplayLabels
                && (
                    <NoTranslate>
                        <StyledHeaderImageWithLabelWrapper>
                            <HeaderTagImageWithLabel
                                src={Images.LOGOS.CLIENT.SRC}
                                alt={Images.LOGOS.CLIENT.ALT}
                                label={client.name}
                                tooltipLabel={`Client: ${client.name}`}
                                shouldDisplayBackground
                            />
                            <HeaderTagImageWithLabel
                                src={account.type
                                    ? Images.LOGOS[account.type.toUpperCase()].SRC : null}
                                alt={account.type
                                    ? Images.LOGOS[account.type.toUpperCase()].ALT : null}
                                label={account.name}
                                tooltipLabel={`Account: ${account.name}`}
                                shouldDisplayBackground
                            />
                        </StyledHeaderImageWithLabelWrapper>
                    </NoTranslate>
                )}
                {client && !account && shouldDisplayLabels
                && (
                    <NoTranslate>
                        <StyledHeaderImageWithLabelWrapper>
                            <HeaderTagImageWithLabel
                                src={Images.LOGOS.CLIENT.SRC}
                                alt={Images.LOGOS.CLIENT.ALT}
                                label={client.name}
                                tooltipLabel={`Client: ${client.name}`}
                                shouldDisplayBackground
                            />
                        </StyledHeaderImageWithLabelWrapper>
                    </NoTranslate>
                )}
                {children}
            </Header>
        </ModalHeaderBackground>
    );
};

ModalHeader.defaultProps = defaultProps;

const Header = styled.header`
    background: url(${({ backgroundImage }) => backgroundImage}) no-repeat center;
    background-size: cover;
    align-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100%;
    line-height: 1;
    position: relative;
    padding-bottom: 46px; 
   
    ${({ headerStyles }) => headerStyles && { ...headerStyles }};

    @media ${MobileScreen} {
        height: unset;
        white-space: unset;
    }
`;

const StyledHeaderImageWithLabelWrapper = styled(HeaderImageWithLabelWrapper)`
    padding: 24px 0;
`;

export default ModalHeader;
